<template>
  <a-table :columns="columns" :scroll="{x: 680,y:500}" :data-source="list" rowKey='name' :pagination="false">
     <template
    v-for="col in valKeys"
    :slot="col"
    slot-scope="text,record"
  >
  <span v-if="col === 'weight'" :key="col">{{((record.mixPercentage || 0) * (details.totalWeight || 0) / 100).toFixed(lenFunc(col))}}</span>
  <span v-else :key="col">
    <!-- <span v-if="record.unit === 'Kcal' || record.unit === 'MJ'">{{ text === '' || text === null ? text : Number(text).toFixed(0)}}</span>
    <span v-else>{{ text === '' || text === null || text === undefined ? text : Number(text).toFixed(lenFunc(col))}}</span> -->
    {{text ? Number(text).toFixed(lenFunc(col,record.unit)) : ''}}
  </span>

  </template>
  </a-table>
</template>
<script>
export default {
  props: ['rowId','url','factoryId','columns','valKeys','details','len'],
  data(){
    return{
      list:[],
      pagination: {
        total:0,
        pageSize:10000,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    lenFunc(col,unit){
      let len = 3
      if(['content','minValue','maxValue'].includes(col)) len = 2
      if(['minValue','maxValue','content'].includes(col) && ['MJ','Kcal'].includes(unit)) len = 0
      return len
    },
    getList(pagination){
      let {current=1,pageSize=10000} = pagination || this.pagination
      let params = {
        formulaId:this.rowId,factoryId: this.factoryId,
        current,size:pageSize
      }
      if(this.rowId){
        this.$http.get(this.url,{params}).then(res => {
          let {success,data} = res;
          if(success){
            this.list = data || []
          }else{
            this.$message.error('查询失败')
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tableBox{
  padding: 0 20px;
}
</style>
